var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editorSettings)?_c('vue-editor',{staticClass:"msp-editor",class:_vm.classEditor,attrs:{"value":_vm.value,"editorOptions":_vm.editorSettings,"placeholder":_vm.placeholder},on:{"text-change":_vm.update,"input":_vm.input}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }